<script>
  import Header from "./Header.svelte";
  import { Route } from "svelte-router-spa";
  export let params;
  export let currentRoute;
</script>

<div id="main-wrapper">
  <Header {currentRoute} />
  <div id="content" role="main">
    <Route {currentRoute} {params} />
  </div>
</div>
